// hooks/useServerAuth.js
import { useState, useEffect } from 'react';
import useUserStore from '@/store/userStore';
import authService from '@/services/authService';

export function useServerAuth(initialAuthState = false, initialUserData = null) {
  const [isServerAuthenticated, setIsServerAuthenticated] = useState(initialAuthState);
  const [serverUserData, setServerUserData] = useState(initialUserData);
  
  const { setUserManually, isLoggedIn, user, loading } = useUserStore();
  
  // При первой загрузке используем серверные данные, если они есть
  useEffect(() => {
    // Проверяем наличие серверных данных и отсутствие клиентских данных
    if (initialAuthState && initialUserData && !isLoggedIn && !user && setUserManually) {
      setUserManually(initialUserData);
    }
    
    // Проверяем JWT токены в localStorage при инициализации
    const verifyInitialAuth = async () => {
      if (!isLoggedIn && !loading) {
        // Пытаемся получить валидный JWT токен
        const token = await authService.getValidToken();
        
        // Если JWT токен получен, но пользователь не установлен, запрашиваем статус авторизации
        if (token && !isLoggedIn && !user) {
          try {
            const authStatus = await authService.checkAuthStatus();
            if (authStatus.authenticated && authStatus.user && setUserManually) {
              setUserManually(authStatus.user);
            }
          } catch (error) {
            console.error('useServerAuth: Ошибка при проверке статуса авторизации:', error);
          }
        }
      }
    };
    
    // Выполняем проверку с небольшой задержкой
    const timer = setTimeout(verifyInitialAuth, 200);
    return () => clearTimeout(timer);
  }, [initialAuthState, initialUserData, isLoggedIn, user, setUserManually, loading]);
  
  // Синхронизируем клиентское состояние с серверным при изменении
  useEffect(() => {
    if (!loading) {
      // Обновляем статус аутентификации, если он изменился
      if (isLoggedIn !== isServerAuthenticated) {
        setIsServerAuthenticated(isLoggedIn);
      }
      
      // Обновляем данные пользователя, если они изменились
      if (isLoggedIn && user && JSON.stringify(user) !== JSON.stringify(serverUserData)) {
        setServerUserData(user);
      }
      
      // Очищаем данные пользователя, если он вышел
      if (!isLoggedIn && serverUserData) {
        setServerUserData(null);
      }
    }
  }, [isLoggedIn, user, loading, isServerAuthenticated, serverUserData]);
  
  return {
    isAuthenticated: isServerAuthenticated,
    userData: serverUserData,
    isLoading: loading
  };
}